import { BooleanInput, NumberInput, SimpleForm, TextInput, required } from "react-admin";
import { LogoInput } from "./LogoInput";

export function BankForm() {
  return (
    <SimpleForm>
      <TextInput source="name" label="Название" validate={required()} fullWidth />
      <LogoInput />
      <NumberInput
        source="fee_pct"
        label="Комиссия банка, %"
        min={0}
        step={0.5}
        helperText="0 — без комиссии. Справочно, в сумму заявки не входит."
      />
      <TextInput
        source="comment"
        label="Комментарий"
        fullWidth
        multiline
        helperText="Необязательно. Если задан — показывается строкой под комиссией в мини-аппе."
      />
      <NumberInput source="sort_order" label="Порядок в списке" min={0} defaultValue={0} />
      <BooleanInput source="enabled" label="Включён" defaultValue={true} />
    </SimpleForm>
  );
}
